import { injectionKey } from '@shared/injection'

const flyOutInjectionKey = injectionKey<ReturnType<typeof setupFlyOut>>('flyOut')

export function setupFlyOut (open?: boolean) {
  let localOpen = $ref(open ?? false)
  let localLocked = $ref(false)

  function setOpen (value: boolean) {
    localOpen = value
  }

  // While locked, the flyout ignores its click-toggle and outside-click close
  // so interactive content (inline editors, dialogs, portalled pickers) can be
  // used without dismissing the menu.
  function setLocked (value: boolean) {
    localLocked = value
  }

  const api = {
    open: $$(localOpen),
    locked: $$(localLocked),
    setOpen,
    setLocked,
  }

  provide(flyOutInjectionKey, api)

  return api
}

export function useFlyOut () {
  let fallbackOpen = $ref(false)
  let fallbackLocked = $ref(false)
  return inject(flyOutInjectionKey, {
    open: $$(fallbackOpen),
    locked: $$(fallbackLocked),
    setOpen: (value) => { fallbackOpen = value },
    setLocked: (value) => { fallbackLocked = value },
  })!
}
